import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class EnterBalancesValidationServiceService {
  private _isRecombinationTableValid: boolean;
  private _isCalendarValid: boolean;
  private _isValidCache: boolean;
  public _listOfValidTables: Array<any> = new Array<any>();
  private validTableSource = new Subject<string>();

  validTable$ = this.validTableSource.asObservable();

  public isValid(): boolean {
    if (this._isValidCache) {
      return true;
    }

    return this._isRecombinationTableValid && this._isCalendarValid;
  }

  set isRecombinationTableValid(isValid: boolean) {
    this._isRecombinationTableValid = isValid;
  }

  set isCalendarValid(isValid: boolean) {
    this._isCalendarValid = isValid;
  }

  get isValidCache() {
    return this._isValidCache;
  }

  set isValidCache(isValidCache: boolean) {
    this._isValidCache = isValidCache;
  }

  broadCastValidTable(table: any) {
    this.validTableSource.next(table);
    this._listOfValidTables.push(table);
    this._listOfValidTables = this.removeDuplicates(this._listOfValidTables, 'recombinationTable');
    this.isRecombinationTablesValid();
  }

  private isRecombinationTablesValid(): void {
    for (const validTable of this._listOfValidTables) {
      if (validTable.isValid) {
        this.isValidCache = false;
        this._isRecombinationTableValid = true;
        return;
      } else {
        this._isRecombinationTableValid = false;
      }
    }
  }

  private removeDuplicates<T>(arr: T[], prop: string) {
    const newArr = [];
    const lookup: Record<string, T> = {};

    for (const value of arr) {
      lookup[value[prop]] = value;
    }

    for (const key of Object.keys(lookup)) {
      newArr.push(lookup[key]);
    }

    return newArr;
  }
}
